import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CadastrarArbitroDto } from '@/types/arbitral/arbitroAdminTypes';

import { arbitrosAdminService } from './services';

export const fetchArbitros = createAsyncThunk(
  'arbitrosAdmin/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      return await arbitrosAdminService.listar();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const cadastrarArbitro = createAsyncThunk(
  'arbitrosAdmin/cadastrar',
  async (data: CadastrarArbitroDto, { rejectWithValue }) => {
    try {
      return await arbitrosAdminService.cadastrar(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const alterarStatusArbitro = createAsyncThunk(
  'arbitrosAdmin/alterarStatus',
  async ({ id, ativo }: { id: string; ativo: boolean }, { rejectWithValue }) => {
    try {
      return await arbitrosAdminService.definirStatus(id, ativo);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
